module.exports = __webpack_public_path__ + "static/media/blockquote.40832078.svg";